const server = process.env.VUE_APP_SERVER_HOST;

export const getID = (url: string) => {
  const index = url.indexOf("assets/");
  const id = url.slice(index + 7, url.length - 1);
  return id;
};

export const getLink = (url: string) => {
  const id = getID(url);
  return server === "engagelab.uio.no"
    ? `https://${server}/edu-futures/#/video/${id}`
    : `http://localhost:8080/video/${id}`;
};
